import { ROUTER_PATHS } from '@/constants/router/paths'

/** フッターの画面遷移用ボタンのラベル（先頭） */
export const FIRST_FOOTER_BUTTON_LABEL = 'ホーム画面'
/** フッターの画面遷移用ボタンのラベル（末尾） */
export const LAST_FOOTER_BUTTON_LABEL = '調査保存'

/**
 * 各調査画面の情報リスト
 * @note 必ず遷移順に並べる（indexで前後を判断するため）
 */
export const inspectionPages = [
  {
    path: ROUTER_PATHS.inspection.root + '/' + ROUTER_PATHS.inspection.basicInfo,
    name: '調査員情報入力'
  },
  {
    path: ROUTER_PATHS.inspection.root + '/' + ROUTER_PATHS.inspection.buildingInfo,
    name: '建築物概要入力'
  },
  {
    path: ROUTER_PATHS.inspection.root + '/' + ROUTER_PATHS.inspection.step1,
    name: '調査 Step1'
  },
  {
    path: ROUTER_PATHS.inspection.root + '/' + ROUTER_PATHS.inspection.step2,
    name: '調査 Step2'
  },
  {
    path: ROUTER_PATHS.inspection.root + '/' + ROUTER_PATHS.inspection.result,
    name: '判定結果'
  }
]
